import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController, ModalController, ToastController } from 'ionic-angular';
import { TPVServices } from "../../../tpv/services";
import { Globals } from "../../../../globals";
import { PrintServices } from "../../../services/printServices";
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServices } from '../../services';
import { InvoicesCreateSelectClientPage } from '../../../invoices/invoices-create/invoices-create-select-client/invoices-create-select-client';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { PopupTicketRefund } from '../../../components/popups/popup-ticket-refund/popup-ticket-refund';
import { CustomersServices } from '../../../customers/services';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import moment from 'moment';
import { PopupTicketStripeRefund } from '../../../components/popups/popup-ticket-stripe-refund/popup-ticket-stripe-refund';
/**
 * Generated class for the ConfigurationTicketsListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-tickets-list',
    templateUrl: 'configuration-tickets-list.html',
})
export class ConfigurationTicketsListPage {
    state: any;
    ticket: any;
    close_cash: boolean = false;
    lists = [];
    list_show = [];
    firestore: any;
    refunded_ticket = [];
    get_refunded_ticket: boolean = false;
    customer: any;
    ticket_timeline: any;
    get_payment_loader = false;
    stripe_payment: any;
    //datatable
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public afs: AngularFirestore,
        public tpvServices: TPVServices,
        public globals: Globals,
        public alertCtrl: AlertController,
        public printServices: PrintServices,
        public datePipe: DatePipe,
        public translate: TranslateService,
        public configurationServices: ConfigurationServices,
        public analyServices: AnalyticsServices,
        public modalCtrl: ModalController,
        public customersServices: CustomersServices,
        public http: HttpClient,
        public toastCtrl: ToastController) {
        //
        this.globals.GAtrackView('Sales', 'Sales - Ticket - View', this.globals.restaurant.email, 'View', 'View ticket', 'Sales', '');
        this.firestore = firebase.firestore();
        //get navParams
        this.state = this.navParams.get('state');
        this.ticket = this.navParams.get('ticket');
        this.close_cash = this.navParams.get('close_cash');
        //preparar list_show
        for (let k in this.ticket.list) {
            this.lists.push(JSON.parse(JSON.stringify(this.ticket.list[k])));
        }
        this.list_show = this.tpvServices.listSelectedTicket('name', this.lists)[0];
        //info para imprimir
        this.tpvServices.ticket_print = 'indv';
        //si tiene refund recuperar ticket del refund
        if (this.ticket.refund_ticket) {
            this.getRefundTicket();
        } else {
            this.get_refunded_ticket = false;
        }
    }

    async ionViewWillEnter() {
        if (this.ticket.customer_uid != undefined && this.ticket.customer_uid != '') {
            this.ticket.customer = await this.customersServices.getCustomer(this.ticket.customer_uid);
            this.customer = this.ticket.customer;
        }
        if (this.ticket.uid_tickettimeline) {
            const params = new HttpParams()
                .set('ticket_timeline', this.ticket.uid_tickettimeline);
            await this.http.post(this.globals.analytics_path + 'get_ticket_timeline', params, {})
                .subscribe(async res => {
                    this.ticket_timeline = res;
                    //Si el ticket es un ticket cancelado, añadimos manualmente la acción de cancelado
                    if (this.ticket.CANCELLED) {
                        this.ticket_timeline.unshift({
                            UID: this.ticket.UID,
                            APP_SECTION: this.ticket.APP,
                            DATE: { value: moment(this.ticket.DATETIME).format('YYYY-MM-DD') },
                            DATETIME: { value: this.ticket.DATETIME },
                            DATE_FORMAT: moment(this.ticket.DATETIME).format('DD/MM/YYYY HH:mm:ss'),
                            HOUR: { value: moment(this.ticket.DATETIME).format('HH:mm:ss') },
                            MOVEMENT: 'Nº ' + this.ticket.NUMBER,
                            TYPE: "cancel ticket",
                            UID_DOC: "",
                            UID_TABLE: "",
                            UID_TICKET: "",
                            UID_WAITER: "",
                            WAITER: this.ticket.WAITER
                        });
                    }
                });
        }
        //
        if (this.globals.restaurant_uid == this.globals.arrosseria_uid) {
            this.get_payment(this.ticket.UID);
        }
    }


    async get_payment(ticket_uid) {
        this.get_payment_loader = false;
        const restRef = this.firestore.collection('tickets').doc(ticket_uid).collection('payment');

        await restRef.get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var payment = doc.data();
                    payment.UID = doc.id;
                    this.stripe_payment = payment;
                    this.get_payment_loader = true;
                });
            });
    }

    /**********************************************************/
    /*                          INIT                          */
    /**********************************************************/

    async getRefundTicket() {
        this.refunded_ticket = await this.configurationServices.getTicket(this.ticket.refund_ticket);
        this.get_refunded_ticket = true;
    }

    /**********************************************************/
    /*                        FUNCIONES                       */
    /**********************************************************/

    async print() {
        await this.firestore.collection('tickets').doc(this.ticket.UID).collection("customer").get().then(snapshot => {
            //Comprobamos si está vacía la snapshot ya que en el caso de que no haya customer, nos mostrarà el anterior
            if (snapshot.empty) {
                this.tpvServices.ticket_print_ind_customer = [];
            }
            else {
                snapshot.forEach(element => {
                    this.tpvServices.ticket_print_ind_customer = element.data();
                });
            }
        });

        var elements_list = [];
        elements_list = this.globals.returnOnlyNoComboElements(this.tpvServices.listSelectedTicket('name', this.lists)[0]);

        //total ayuda
        var total = this.ticket.amount;

        this.tpvServices.ticket_print_ind = elements_list;
        this.tpvServices.ticket_print_ind_number = this.ticket.number;
        this.tpvServices.ticket_print_ind_date = this.globals.timestampToDate(this.ticket.date);
        this.tpvServices.total_ticket_indv_print = this.ticket.amount;

        this.tpvServices.ticket_print_ind_waiter = this.ticket.waiter;
        this.tpvServices.ticket_print_ind_room = this.ticket.room;
        this.tpvServices.ticket_print_ind_table = this.ticket.table;

        if (this.ticket.tip) {
            this.tpvServices.tip_ticket_indv_print = this.ticket.tip;
            //restar la propina para que no se calcule los impuestos
            total -= this.ticket.tip;
        } else {
            this.tpvServices.tip_ticket_indv_print = 0;
        }

        if (!this.ticket.waiter) {
            this.ticket.waiter = '';
        }
        if (!this.ticket.room) {
            this.ticket.room = '';
        }
        if (!this.ticket.table) {
            this.ticket.table = '';
        }

        var subtotal = this.globals.createSubTotal(total, this.ticket.tax);//this.ticket.amount - (this.ticket.amount * this.ticket.tax / 100);
        this.tpvServices.subtotal_ticket_indv_print = subtotal;


        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-imprimir-ticket'),
            message: this.translate.instant('instant-seguro-quieres-imprimir-ticket'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                        this.tpvServices.ticket_print_ind = [];
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Sales', 'Sales - Ticket - print', this.globals.restaurant.email, 'Create/Update', 'Print ticket', 'Sales', '');
                        this.globals.print_content = document.getElementById('print_list_ticket_indv');
                        //interval para imprimir correctamente
                        var interval = setInterval(() => {
                            this.printServices.printNow('print_list_ticket_indv');
                            this.tpvServices.ticket_print_ind = [];
                            clearInterval(interval);
                        }, 1000);

                    }
                }
            ]
        });
        alert.present();
    }

    printNoNative(printer_type) {
        var total = this.ticket.amount;
        if (this.ticket.tip) {
            total -= this.ticket.tip;
        }
        var subtotal = this.globals.createSubTotal(total, this.ticket.tax);
        this.tpvServices.subtotal_ticket_indv_print = subtotal;

        this.printServices.prepareTicket(this.tpvServices.listSelectedTicket('name', this.lists)[0]
            , this.globals.timestampToDate(this.ticket.date)
            , subtotal
            , this.ticket.amount
            , total - subtotal
            , this.ticket.waiter
            , this.ticket.room
            , this.ticket.table
            , this.globals.restaurant.tickets.footer
            , 'tpv'
            , this.ticket.number
            , this.ticket
            , printer_type
            , true
            , this.ticket.notes || this.ticket.employee_comment || '' );
    }

    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.pop();
        loadingPopup.dismiss();
    }

    createInvoice(ticket) {
        this.navCtrl.push(InvoicesCreateSelectClientPage, {
            origin: 'ticket',
            ticket: ticket,
            customer: this.customer
        });
    }

    refund(ticket) {
        //open modal
        let profileModal = this.modalCtrl.create(PopupTicketRefund,
            {
                ticket: ticket,
            });
        profileModal.onDidDismiss(async data => {
            if (data) {
                if (data.REFUND === 'SUCCESS') {
                    let loadingPopup = this.loadingCtrl.create({
                        spinner: 'crescent',
                        content: this.translate.instant("instant-generando-ticket-devolucion")
                    });
                    loadingPopup.present();
                    await this.refundTicketFirebase(ticket, data);
                    loadingPopup.dismiss();
                }
            }

        });
        profileModal.present();
    }

    refundStripe(ticket, stripe_payment) {
        if (stripe_payment.id.includes('pi')) {
            //open modal
            let profileModal = this.modalCtrl.create(PopupTicketStripeRefund,
                {
                    ticket: ticket,
                });
            profileModal.onDidDismiss(async data => {
                if (data) {
                    let loadingPopup = this.loadingCtrl.create({
                        spinner: 'crescent',
                        content: "Refunding stripe ticket"
                    });
                    loadingPopup.present();
                    const params = new HttpParams()
                        .set('payment_intent', stripe_payment.id)
                        .set('connected_acount', this.globals.restaurant.connected_acount)
                        .set('amount', data.total_refund);
                    this.http.post(this.globals.analytics_path + 'stripe/webpay_refund_pi', params, {})
                        .subscribe(async res => {
                            if (res['transaction']) {
                                data.total_refunded = data.total_refund;
                                data.refund_reason = "";
                                ticket.takeaway_stripe_refund = true;
                                //create refund ticket
                                await this.refundTicketFirebase(ticket, data);
                                //update -> refund true
                                await this.afs.collection('tickets').doc(ticket.UID).update({
                                    'takeaway_stripe_refund': true
                                });
                                //add object refund to subcollection in tickets
                                await this.afs.collection('tickets').doc(ticket.UID).collection('refund').add(res['refund']);
                            } else {
                                let toast = this.toastCtrl.create({
                                    message: this.globals.ifVarEmpty(res['error'].raw.message),
                                    duration: 5000,
                                    position: 'top'
                                });
                                toast.present();
                            }
                            loadingPopup.dismiss();
                        });
                }

            });
            profileModal.present();
        }
    }

    async refundTicketFirebase(ticket, data) {
        //duplicate ticket
        var refunded_ticket = JSON.parse(JSON.stringify(ticket));
        //change number to refund
        refunded_ticket.number = "R-" + refunded_ticket.number;
        //add into list line of the refund
        refunded_ticket.list = [{
            name: this.translate.instant("general-devolucion"),
            price: -Math.abs(data.total_refunded),
            delete: false,
            count: true,
            type: '',
            uid_element: '',
            waiter: this.globals.waiter,
            waiter_uid: this.globals.waiter_uid,
            units: 1,
        }];
        //prepare data
        refunded_ticket.amount = -Math.abs(data.total_refunded);//amount minus total refunded
        refunded_ticket.refund = true;//refunded
        refunded_ticket.date = new Date();
        refunded_ticket.refund_reason = data.refund_reason;
        refunded_ticket.refund_total = data.total_refunded;
        //add new ticket ref
        await this.afs.collection('tickets').add(refunded_ticket).then(async doc => {
            //actualizar en ticket
            this.afs.collection('tickets').doc(ticket.UID).update({
                refund: refunded_ticket.refund,
                refund_ticket: doc.id,
            }).then(c_doc => {
                this.ticket = ticket;
                //
                this.lists = [];
                for (let k in this.ticket.list) {
                    this.lists.push(this.ticket.list[k]);
                }
                this.list_show = this.tpvServices.listSelectedTicket('name', this.lists)[0];
                this.navCtrl.pop();
            });
        });
        //create ticket timeline
        var movement = refunded_ticket.number.toString() + ' - ' + data.total_refunded.toFixed(2) + '' + this.globals.currency_symbol + ' - ' + refunded_ticket.refund_reason;
        var ticket_timeline = {
            uid: this.globals.restaurant_uid,
            uid_doc: ticket.uid_tickettimeline,
            uid_table: ticket.table_uid,
            uid_ticket: ticket.UID,
            type: 'refund ticket',
            waiter: this.globals.user_name,
            uid_waiter: this.globals.user_uid,
            movement: movement,
            app_section: 'APP2',
            date: new Date()
        }
        this.analyServices.ticketTimeline(ticket_timeline);
    }

    openRefundedTicket() {
        this.navCtrl.pop();
        this.navCtrl.push(ConfigurationTicketsListPage, {
            state: 'closed',
            ticket: this.refunded_ticket,
        });
    }

    getSectionType(value) {
        var _return = '';
        value = value.split(' - ');
        switch (value[0].toLowerCase()) {
            case 'tpv':
                _return = this.translate.instant('general-tpv');
                if (value[1]) {
                    _return += ' - ' + value[1];
                }
                break;
            case 'orders':
                _return = this.translate.instant('general-comandero');
                if (value[1]) {
                    _return += ' - ' + value[1];
                }
                break;
            case 'takeaway':
                _return = this.translate.instant('general-takeaway');
                if (value[1]) {
                    _return += ' - ' + value[1];
                }
                break;
            case 'mct pay':
                _return = this.translate.instant('general-mycheftool') + ' Pay';
                break;
            default:
                _return = value;
        }
        return _return;
    }

    getMovementText(value, type) {
        var _return = '';
        if (type.includes('pay')) {
            _return = parseFloat(value).toFixed(2) + this.globals.currency_symbol
        } else {
            switch (type) {
                case 'print ticket':
                    _return = 'Nº ' + value;
                    break;
                case 'refund ticket':
                    _return = 'Nº ' + value;
                    break;
                case 'refund ticket':
                    _return = 'Nº ' + value;
                    break;
                case 'create invoice':
                    _return = 'Nº ' + value;
                    break;
                default:
                    _return = value;
            }
        }
        return _return;
    }

    trFontColor(ticket) {
        if (ticket.refund && ticket.amount < 0) {
            let cssClasses = {
                'text-danger': true,
            };
            return cssClasses;
        }
        return '';
    }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-tickets/configuration-tickets-list/configuration-tickets-list.ts